import { useCallback, useEffect, useRef, useState } from 'react';
export const useScrollVisibility = _ref => {
  let {
    tabButtons,
    selectedTabId,
    onSelectTab
  } = _ref;
  const [isScrollLeftButtonVisible, setIsScrollLeftButtonVisible] = useState(false);
  const [isScrollRightButtonVisible, setIsScrollRightButtonVisible] = useState(false);
  const tabsContentRef = useRef(null);
  const firstTabElement = tabButtons[0];
  const lastTabElement = tabButtons[tabButtons.length - 1];
  const setScrollButtonsVisibility = useCallback(() => {
    if (!tabsContentRef.current || window.innerWidth > 840) return setIsScrollRightButtonVisible(false), setIsScrollLeftButtonVisible(false);
    const hasOverflow = tabsContentRef.current.scrollWidth > tabsContentRef.current.offsetWidth;
    if (!hasOverflow) return setIsScrollRightButtonVisible(false), setIsScrollLeftButtonVisible(false);
    if (selectedTabId === lastTabElement.props.id) {
      setIsScrollRightButtonVisible(false);
    }
    if (selectedTabId === firstTabElement.props.id) {
      setIsScrollLeftButtonVisible(false);
    }
    if (selectedTabId !== lastTabElement.props.id) {
      setIsScrollRightButtonVisible(true);
    }
    if (selectedTabId !== firstTabElement.props.id) {
      setIsScrollLeftButtonVisible(true);
    }
  }, [firstTabElement.props.id, lastTabElement.props.id, selectedTabId]);
  useEffect(() => {
    window.addEventListener('resize', setScrollButtonsVisibility);
    return () => {
      window.removeEventListener('resize', setScrollButtonsVisibility);
    };
  }, [setScrollButtonsVisibility]);
  useEffect(() => {
    setScrollButtonsVisibility();
  }, [setScrollButtonsVisibility]);
  const handleShiftButtonClick = side => {
    var _a;
    const selectedButton = (_a = tabsContentRef === null || tabsContentRef === void 0 ? void 0 : tabsContentRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('button[aria-selected="true"]');
    if (side === 'left') {
      const previousButton = selectedButton === null || selectedButton === void 0 ? void 0 : selectedButton.previousElementSibling;
      previousButton === null || previousButton === void 0 ? void 0 : previousButton.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
      onSelectTab(previousButton === null || previousButton === void 0 ? void 0 : previousButton.id);
    }
    if (side === 'right') {
      const nextButton = selectedButton === null || selectedButton === void 0 ? void 0 : selectedButton.nextElementSibling;
      nextButton === null || nextButton === void 0 ? void 0 : nextButton.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
      onSelectTab(nextButton === null || nextButton === void 0 ? void 0 : nextButton.id);
    }
  };
  return {
    isScrollLeftButtonVisible,
    isScrollRightButtonVisible,
    handleShiftButtonClick,
    tabsContentRef
  };
};
useScrollVisibility.displayName = 'useScrollVisibility';